
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_1kosq_pz086_9",
  "breadcrumb": "awsui_breadcrumb_1kosq_pz086_13",
  "ghost-breadcrumb": "awsui_ghost-breadcrumb_1kosq_pz086_14",
  "icon": "awsui_icon_1kosq_pz086_17",
  "anchor": "awsui_anchor_1kosq_pz086_27",
  "text": "awsui_text_1kosq_pz086_75",
  "last": "awsui_last_1kosq_pz086_94"
};
  